import { loadStripe } from '@stripe/stripe-js';

// Stripe publishable key
const STRIPE_PUBLISHABLE_KEY = 'pk_live_wbB9Jot0yPx7VkOtLAzlJ3uu';

// Initialize Stripe
export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

// Stripe configuration
export const STRIPE_CONFIG = {
  publishableKey: STRIPE_PUBLISHABLE_KEY,
  successUrl: 'https://tee-time-finder-2025-9b689.web.app/payment-success',
  cancelUrl: 'https://tee-time-finder-2025-9b689.web.app/upgrade'
};

export const getStripeConfig = () => ({
  publishableKey: STRIPE_PUBLISHABLE_KEY,
  successUrl: 'https://tee-time-finder-2025-9b689.web.app/payment-success',
  cancelUrl: 'https://tee-time-finder-2025-9b689.web.app/upgrade'
}); 